"use strict";

(function (root, f) {
  if (typeof exports === "object") {
    // CommonJS
    module.exports = f();
  } else {
    $KabalaI18n.$extend("zh-CN", f());
  }
})(this, function () {
  return {
    k: {
      // 按钮
      button: {
        new: "新建",
        add: "添加",
        edit: "修改",
        del: "删除",
        copy: "复制",
        move: "移动",
        rename: "重命名",
        select: "选择",
        save: "保存",
        reset: "重置",
        yes: "是",
        no: "否",
        ok: "确定",
        submit: "提交",
        cancel: "取消",
        clear: "清空",
        close: "关闭",
        back: "返回",
        refresh: "刷新",
        mkfolder: "新建文件夹",
        upload: "上传",
        update: "更新",
        download: "下载",
        preview: "预览",
        search: "搜索",
        details: "详情",
        permission: "权限",
        send: "发送",
        export: "导出",
        query: "查询",
        moveup: "上移",
        movedown: "下移",
        fullscreen: "全屏显示",
        exit_fullscreen: "退出全屏",
        updatepwd: "修改密码",
        showmore: "显示更多",
        showless: "显示更少",
        helperdownload: "助手下载",
        diff: "对比",
        login: "登录",
        logout: "退出登录",
      },
      // 选择
      select: {
        file: "选择文件",
        folder: "选择文件夹",
        user: "选择用户",
        group: "选择部门",
        role: "选择角色",
        template: "选择模板",
      },
      // 文字
      text: {
        noData: "暂无数据",
        clearCacheInfo: "您确定要清理缓存吗？",
        signoutInfo: "您确定要退出吗？",
        changeLanguage: "修改语言",
        viewDetail: "查看详情",
        fileitems: "个文件",
        people: "人",
        docs: "云盘",
        message: "消息",
        platform: "应用",
        my: "我的",
        true: "是",
        false: "否",
        all: "全部",
        none: "无",
        system: "系统",
        tag: "标签",
        data: "数据",
        status: "状态",
        nodata: "暂无数据",
        rootnode: "根节点",
        location: "位置",
        remark: "备注",
        keywords: "关键词",
        unread: "未读",
        hasread: "已读",
        operations: "操作",
        title: "标题",

        account: "账号",
        accountormobile: "账号或手机号",
        username: "用户名",
        password: "账号密码",
        user: "用户",
        group: "部门",
        role: "角色",
        jobnumber: "工号",
        jobpost: "职务",
        userscope: "用户范围",
        setpassword: "设置密码",
        oldpassword: "旧密码",
        newpassword: "新密码",
        vcode: "验证码",
        finalpassword: "确认密码",
        email: "邮箱",
        phonenumber: "手机号",
        officephone: "办公电话",
        myaccountinfo: "个人资料",
        everyone: "所有人",
        avatar: "头像",

        dir: "目录",
        file: "文件",
        image: "图片",
        folder: "文件夹",
        name: "名称",
        size: "大小",
        filesize: "文件大小",
        creator: "创建者",
        version: "版本",
        ctime: "操作时间",
        mtime: "更新时间",
        optip: "操作IP",
        filenameorbody: "名称与内容",
        filename: "名称检索",
        filebody: "内容检索",
        filetag: "标签检索",
        filemeta: "属性检索",
        fileall: "模糊检索",
        // filename: '文件名称',
        // filebody: '文件内容',
        filetype: "文件类型",
        parentdir: "上级目录",
        spacetype: "所属空间",
        filedetails: "文件详情",
        folderdetails: "文件夹详情",
        opttype: "操作类型",
        operationuser: "操作人",
        operationdesc: "操作描述",

        thumbnail: "缩略图",
        list: "列表",
        helpinfo: "帮助信息",
        mustinput: "必填项",
        systemmanagement: "系统管理",
        supportbykass: "上海开始网络科技有限公司提供技术支持",
        baseinfo: "基本信息",
        basedatas: "基本数据",
        notice: "流程须知",
        languagesetting: "语言设置",
        nowlanguage: "当前语言",
        searchresult: "搜索结果",

        open: "打开",
        edit: "修改",
        del: "删除",
        preview: "预览",
        download: "下载",
        transpdf: "导出PDF",
        display: "显示",
        display_none: "不显示",
        delete_record: "删除记录",
        delete_file: "删除文件",
        openinnewwindow: "新窗口打开",
        selectedmultiple: "当前选中了{0}项",
        selected: "已选中",
        moving: "正在移动",
        copying: "正在复制",
        moreoperations: "更多操作",

        countfile: "{0}个文件",
        countfolder: "{0}个文件夹",

        downloadtips: "下载提示",
        ask_helperdownload: "建议您使用文件助手下载",

        search: {
          by: {
            all: "全局检索",
            fast: "快速检索",
            name: "按名称检索",
          },
        },
        select: {
          multiple: "多选",
          single: "单选",
          dir: "选择目录",
        },
        filediff: "文件对比",
        privacy: "隐私声明",
        clearCache: "清空缓存",
      },
      // 询问(动作类)
      ask: {
        delete: {
          record: "您确认需要删除此记录?",
          file: "您确认需要删除所选的文档?",
          permission: "是否删除此权限?",
        },
        login: {
          succeed: "登录成功,是否刷新页面?",
        },
        diff: {
          goon: "您已选择两个相同文件是否立即对比?",
        },
        text: "您确认",
      },
      // 提示(动作类)
      tips: {
        title: "提示",
        // xxx 不能
        cannot: {
          // 描述
          none: {
            mustinput: "{0}不能为空",
            name: "名字不能为空",
            username: "用户名不能为空",
            account: "账户不能为空",
          },
        },
        // xxx 已存在
        exist: {
          name: "名称已存在",
        },
        // xxx 不存在
        notexist: {
          file: "文件不存在",
          details: "详情页面不存在",
          template: "模板不存在",
        },
        // 正在做 xxx
        ing: {
          export: "正在导出",
          upload: "正在上传",
          initializ: "正在初始化",
          save: "正在保存",
          calc_file_info: "正在计算文件信息",
          search: "检索中",
        },
        // 成功
        succeed: {
          // 做xxx成功了
          when: {
            reload: "刷新成功",
            rename: "重命名成功",
            new: "新建成功",
            operation: "操作成功",
            upload: "上传成功",
            save: "保存成功",
            mkfolder: "文件夹创建成功",
            move: "移动成功",
            copy: "移复制功",
            delete: "删除成功",
            clearCache: "清除成功",
          },
        },
        // 错误提示
        error: {
          // 失败后做 xx 动作
          please: {
            refresh: "出现错误, 请刷新页面重试",
          },
          // 做什么失败了
          when: {
            rename: "重命名失败",
            new: "新建失败",
            upload: "上传失败",
            download: "下载失败",
            move: "移动失败",
            copy: "复制失败",
            save: "保存失败",
            delete: "删除失败",
            search: "搜索失败",
            emptypath: "不支持在该模式下检索",
            loginexpired: "登录过期, 请重新登录",
            template_not_bound: "模板未绑定",
            unzip: "解压失败",
            zip: "压缩失败",
            loading: "正在加载中, 请稍后重试",
          },
          versionexist: "文件版本已存在",
          diffconflict: "请选择两份相同类型的文件进行对比",
          notsupport: "不支持该操作",
        },
        // 请
        please: {
          // 输入 xxx
          input: {
            password: "请输入密码",
            oldpassword: "请输入旧密码",
            finalpassword: "请输入确认密码",
            account: "请输入账户",
            code: "请输入验证码",
            phone: "请输入手机号",
            words2search: "输入关键词检索",
          },
          // 选择
          select: {
            // 一个 xxx
            one: {
              to: "请选择一项",
              data: "请选择一项数据",
              user: "请选择一个用户",
              file: "请选择一个文件",
              folder: "请选择一个文件夹",
              userorgroup: "选择一个用户或部门",
              group: "选择一个部门",
            },
            // 大于1个
            gtone: {
              to: "请选择至少一项",
            },
          },
        },
      },

      // 通用组件语言包
      cpt: {
        // 流程
        flow: {
          const: {
            taskopt: {
              approve: "通过",
              reject: "拒绝(终止流程)",
              restart: "驳回到发起",
              refused: "驳回到上一步",
            },
            taskstatus: {
              wait: "处理中",
              finish: "已处理",
              transfer: "已转移",
              cancel: "已取消",
            },
            flowstatus: {
              turndown: "被驳回",
              runing: "审批中",
              stoped: "已终止",
              end: "已完结",
            },
            tasktransfer: {
              transfer: "转交",
              counterssign: "加签",
              cancelcounterssign: "取消会签",
              cc: "抄送",
              rollback: "回滚",
            },
            counterssignrule: {
              all: "所有人通过则通过",
              one: "一个人通过则通过",
              frist: "以首个审批人为准",
            },
            nodeusertype: {
              user: "指定用户",
              org: "指定部门",
              role: "指定角色",
              form: "表单用户",
              launcher: "发起人本身",
              leader1: "发起人一级主管",
              leader2: "发起人二级主管",
              leader3: "发起人三级主管",
              leader4: "发起人四级主管",
              leader5: "发起人五级主管",
            },
          },
        },
        // 标签按钮
        tagbtn: {
          title: {
            when: {
              delete: "删除提示",
            },
          },
          ask: {
            when: {
              delete: "您确定需要移除文件的标签?",
            },
          },
        },
        // 用户头像
        userheader: {
          deleted: "已删除",
        },
        // 文件图标
        fileicon: {
          lockdesc: "{0}于{1}锁定",
        },
        // 用户选择框
        usertreedialog: {
          search: "搜索用户、部门",
          result: "选择结果",
        },
        // 短信发送
        sendsms: {
          smstext: "获取验证码",
          placeholder: "输入验证码",
          please_input_code: "请输入图中验证码",
          click_img_refresh: "看不清? 点击图片刷新",
          dosendsms: "立即发送",
          faild_send: "图片验证码生成失败",
          err_phone_format: "手机号码格式不正确",
          succeed_send: "短信发送成功",
        },
        // 助手程序
        kabalahelper: {
          tips: {
            start: "正在启动文件助手,请稍等...",
            not_intall: "您未安装助手",
          },
          title: {
            check: "助手检测",
          },
          text: {
            not_install: "系统检测到您未安装文件助手，建议",
            download: "下载助手",
          },
        },
        // 预览文件
        preview: {
          button: {
            spin: "旋转",
            shrink: "缩小",
            enlarge: "放大",
            vieworiginal: "查看原图",
          },
          tips: {
            ing: {
              preview: "正在准备预览文件,请稍等...",
            },
            when: {
              notsupport:
                "文件类型无法在线预览(或文件后台转换中),推荐下载后打开",
            },
          },
          text: {
            workinggroupdocument: "工作组文件",
          },
        },
        // 文件详情
        fsdetail: {
          tips: {
            when: {
              emptyshowurl: "该路径没有详情展示页面",
            },
          },
        },
        // total-explorer
        totalexplorer: {
          tips: {
            when: {
              emptypath: "不支持在该模式下检索",
            },
          },
        },
        // totalfiledialog
        totalfiledialog: {
          title: {
            doclibs: "文件库",
          },
        },
        // filetreedialog
        filetreedialog: {
          button: {
            uploadfile: "上传本机附件",
          },
        },
        // space-io
        spaceio: {
          tips: {
            when: {
              cmp: "云端正在为您准备压缩文件,请稍等",
              cmperror: "压缩失败",
              deletesucceedcout: "成功删除{0}个节点",
            },
            ing: {
              count: "正在统计您选择的文档信息,请稍等",
              batexec: "正在批量执行任务,请稍等",
            },
          },
          ask: {
            when: {
              move: "您确定需要将选择的节点移动到: {0}",
              copy: "您确定需要将选择的节点复制到: {0}",
            },
          },
          button: {
            move: "开始移动",
            copy: "开始复制",
          },
          title: {
            move: "移动提示",
            copy: "复制提示",
            delete: "删除提示",
          },
          text: {
            optcount: "本次任务操作文档数量: {0}",
            succeedcount: "操作结束,已完成数量: {0}",
            failedlist: "失败文件清单",
          },
        },
        // space-explorer
        spaceexplorer: {
          tips: {
            when: {
              emptypath: "不支持在该模式下检索",
            },
          },
        },
        // space-explorer-datalist
        spaceexplorerdatalist: {
          text: {
            searchstatus: "您正在全局检索(名称或标签)",
          },
        },
        uploader: {
          tips: {
            error: {
              cannotstop: "无法暂停,有文件正在计算信息",
              transportfailedcount: "{0}项任务传输失败",
            },
            succeed: {
              transportokcount: "{0}项任务已完成",
            },
          },
          ask: {
            close: "您确定需要关闭并终止所有传输任务?",
          },
          button: {
            start: "开始上传",
            append: "继续添加",
            pause: "暂停上传",
            cancel: "取消上传",
          },
          text: {
            hashing: "正在尝试秒传",
            pause: "暂停",
            wait: "等待上传",
            notask: "暂无传输任务",
            transporting: "文件传输中",
          },
        },
      },
    },
    pan: {
      button: {
        preview: "预览",
        download: "下载",
        upload: "上传",
        new_folder: "新建文件夹",
        downloadzip: "打包下载",
        wpsedit: "共享编辑",
        helperopen: "助手打开(只读)",
        helperedit: "助手修改",
        detail: "查看详情",
        print: "打印文件",
        previousnode: "上一个节点",
        addtag: "添加标签",
        addfilelevel: "文件定密",
        finaldraft: "定稿",
        difffiles: "对比",
        rversion: "回滚",
        delete: "删除",
        add: "添加",
        edit: "修改",
        save: "保存",
        listsubdir: "列出子目录",
        listsubfilepms: "列出文件权限",
        more: "更多",
        add_businessform: "添加业务表单",
        query: "查询",
        export: "导出",
        select: "选择",
        unlockfile: "解锁",
        lockfile: "锁定",
        sharelink: "分享",
        initiate_teamcollaboration: "发起团队协作",
        unfavorite: "取消收藏",
        restore: "恢复",
        delete_completely: "彻底删除",
        refresh: "刷新",
        cancel: "取消",
        ok: "确定",
        create: "创建",
        update_now: "立即更新",
        update: "更新",
        new: "新建",
        helper_upload_dir: "助手上传目录",
        helper_upload_largefile: "助手上传大文件",
        rename: "重命名",
        list_mode: "列表模式",
        thumbnail_mode: "缩略图模式",
        start_copying: "开始复制",
        create_cooperation: "创建协作",
        delete_cooperation: "删除协作",
        come_back: "返回上级",
        unselect_all: "全不选",
        select_all: "全选",
        of_share: "的分享",
        join_editor: "加入编辑",
        visit_now: "立即访问",
        acces_official_website: "访问官网",
        close: "关闭",
        not_download: "不可下载",
        send_to_colleague: "发送给同事",
        external_link: "外部链接",
        save_to: "转存",
        open_share: "打开分享",
        unshare: "取消分享",
        copylink: "复制链接",
        unsubscribe: "取消关注",
        clear: "清空",
        selectuser: "选择用户",
        start_statistics: "开始统计",
        select_dir: "选择目录",
        export_excel: "导出excel",
        select_analysis_file: "选择需要分析的文件",
        select_analysis_user: "选择需要分析的用户",
        empty_selected_files: "清空所选文件",
        empty_selected_user: "清空所选用户",
        export_records: "导出记录",
        hide_conditional_area: "隐藏条件区域",
        show_condition_area: "显示条件区域",
        related_pms_settings: "相关权限设置",
        file_pms_details: "文件权限明细",
        start_restore: "开始恢复",
        select_resigners: "选择离职用户",
        select_handover_user: "选择交接用户",
        start_transfer: "开始转移",
        start_moving: "开始移动",
        move_up: "上移",
        move_down: "下移",
        export_secret_doc: "导出当前密级文件",
        see_more: "查看更多",
        return: "返回",
        view_access_log: "查看访问日志",
        view_his_links: "查看历史链接",
        send_immediately: "立即发送",
        return_parentdir: "返回上级目录",
        export_filelist: "导出文件清单",
        copy: "复制",
        reset: "重置",
        remove: "移除",
        add_related: "添加关联",
        remove_related: "解除关联",
        related_newv: "关联最新版本",
        show: "显示",
        hiden: "隐藏",
        linkShare:'链接分享',
        wechatShare:'微信分享',
        teamShare:'同事分享',
        onlineEdit:'在线编辑',
        viewDetail:'查看详情',
        appShare:'应用分享',
      },
      menu: {
        preview: "预览",
        download: "下载",
        downloadzip: "打包下载",
        helperopen: "助手打开(只读)",
        helperedit: "助手修改",
        wpsedit: "共享编辑",
        sharelink: "分享",
        lockfile: "锁定",
        unlockfile: "解锁",
        update: "上传更新",
        zip: "云压缩",
        unzip: "云解压",
        copy: "复制到",
        move: "移动到",
        rename: "重命名",
        delete: "删除",
        payattention: "关注",
        cancelpayattention: "取消关注",
        collect: "收藏",
        cancelcollect: "取消收藏",
        print: "打印文件",
        transpdf: "导出PDF",
        detail: "查看详情",
        export: "导出",
        company_dir_management: "公司目录管理",
        dir_manager_setting: "目录管理员设置",
        dir_config_detail: "目录配置详情",
        dir_pms_detail: "目录权限详情",
        dir_attention_detail: "目录关注详情",
        lockfile_list: "文件锁定列表",
        file_tag_class_management: "文件标签分类管理",
        file_level_management: "文件密级管理",
        file_level_setting: "文件密级定密",
        file_level_list: "文件密级清单",
        add_monitoring_task: "添加敏感监控任务",
        company_space_report_analysis: "公司空间报表分析",
        file_operation_log: "文件操作日志",
        file_usage_rank: "文件使用排名",
        user_behavior_analysis: "用户行为分析",
        operation_count: "操作次数统计",
        incremental_trend_graph: "增量趋势图",
        update_trend_graph: "更新趋势图",
        delete_trend_graph: "删除趋势图",
        external_link_access_log: "外链访问日志",
        dir_structure_export: "目录结构导出",
        pms_setting_list: "权限设置清单",
        user_pms_list: "用户权限清单",
        personal_space_management: "个人空间管理",
        usage_statistics: "使用情况统计",
        file_type_statistics: "文件类型统计",
        personal_space_allowance: "个人空间限额",
        team_space_management: "团队空间管理",
        recycle_bin_management: "回收站管理",
        company_doc_recycle_bin: "公司文档回收站",
        resignation_data_transfer: "离职数据转移",
      },
      title: {
        file_detail: "文件详情",
        dir_detail: "文件夹详情",
        select_filetag: "选择文件标签",
        edit_diradmin: "修改目录管理员",
        add_diradmin: "添加目录管理员",
        confirm_delet: "确认删除",
        select_form: "选择表单",
        setup_pms: "设置权限",
        addfilter: "添加筛选条件",
        modify_space_allowance: "修改空间限额",
        add_space_allowance: "添加空间限额",
        add_attention: "添加关注",
        update: "上传更新",
        zip: "云压缩",
        new_file: "新建文件",
        confirm_operation: "确认操作",
        doc_dir: "文档目录",
        copy_tips: "复制提示",
        move_tips: "移动提示",
        delete_tips: "删除提示",
        lockfile_tips: "锁定提示",
        download_tips: "下载提示",
        business_form: "业务表单",
        create_tag: "创建标签",
        filetag: "文件标签",
        set_password: "设置密码",
        delete_cooperation: "删除协作",
        cooperation: "协作",
        cooperation_detail: "团队协作详情",
        create_cooperation_space: "创建团队协作空间",
        teamdoc: "团队文档",
        KassCloud: "开始云盘",
        start_shared_editing: "开始共享编辑",
        tips_info: "提示信息",
        access_err: "访问出错",
        share_detail: "分享详情",
        company_dir_config_detail: "公司目录配置详情",
        pms_setting_details: "权限设置详情",
        pms_setting_logs: "权限设置日志",
        user_pms_query: "用户权限查询",
        pmslist: "权限列表",
        restore_tips: "恢复提示",
        modify_sensitive_monitoring_tasks: "修改敏感监控任务",
        add_sensitive_monitoring_tasks: "添加敏感监控任务",
        modify_file_level: "修改文件密级",
        add_file_level: "添加文件密级",
        modify_tag_group: "修改标签组",
        add_tag_group: "添加标签组",
        modify_tag: "修改标签",
        add_tag: "添加标签",
        share_link_access_log: "分享链接访问日志",
        sharelink: "分享",
        related_detail: "关联详情",
      },
      tips: {
        ziping: "云端正在为您准备压缩文件,请稍等...",
        pdfing: "云端正在为您准备生成PDF文件,请稍等...",
        printing: "云端正在为您准备打印文件,请稍等...",
        download_fail: "下载失败",
        dir_is_empty: "目标文件为空文件夹",
        zip_fail: "压缩失败",
        select_a_file: "请选择一个文件",
        confirm_jump: "您确定离开详情界面跳转到当前路径?",
        ask_delete: "您确定要删除吗?",
        ask_delete_selectedfile: "您确认需要删除所选的文档?",
        ask_lock_selectedfile: "您确认需要锁定所选的文档?",
        ask_unsubscribe_selectedfolder: "您确定需要取消关注所选文件夹?",
        ask_delete_completely_selectedfile: "您确认需要彻底删除所选的文档?",
        ask_delete_selectedtag: "您确定需要删除所选标签?",
        ask_delete_selected_filelevel: "您确定需要删除所选密级?",
        ask_delete_tag: "您确定要删除此标签吗?",
        ask_delete_filelevel: "您确定要删除此密级吗?",
        ask_delete_selectedpms: "您确定需要删除所选权限?",
        ask_delete_config: "您确定需要删除所选配置?",
        ask_delete_level: "您确定要删除此密级吗?",
        ask_delete_selectedtask: "您确定需要删除所选任务?",
        filetag_add_success: "文件标签添加成功",
        filetag_add_failed: "文件标签添加失败",
        filetag_remove_success: "文件标签移除成功",
        filetag_remove_failed: "文件标签移除失败",
        this_level_existed: "该密级已存在",
        filelevel_add_success: "文件密级设置成功",
        filelevel_add_failed: "文件密级设置失败",
        filelevel_remove_success: "文件密级移除成功",
        filelevel_remove_fail: "文件密级移除失败",
        no_preview_pms: "您没有权限预览",
        success_operation: "操作成功",
        operation_failed: "操作失败",
        select_at_least_one: "请选择至少一项进行操作",
        select_one: "请选择一项进行操作",
        delete_success: "删除成功",
        delete_failed: "删除失败",
        save_success: "保存成功",
        save_fail: "保存失败",
        ask_delete_businessform: "您确认删除此业务表单吗?",
        select_one_businessform: "请选择一个业务表单",
        pms_denied: "您没有权限",
        no_more_data: "没有更多数据了",
        chart_loading_failed: "图表加载失败",
        size_must_be_a_number: "限制的大小必须为数字",
        operation_type_cannot_be_empty: "操作类型不能为空",
        no_log_info_found: "没有查到日志信息",
        path_cannot_be_jumped: "该路径无法跳转",
        unfollow_successfully: "取消关注成功",
        unfollow_failed: "取消关注失败",
        followed: "关注成功",
        follow_failed: "关注失败",
        cannot_move_to_the_root_dir: "不能复制到协作区根目录",
        file_moved_successfully: "文件移动成功",
        file_move_failed: "文件移动失败",
        file_copied_successfully: "文件复制成功",
        copy_successfully: "复制成功",
        successfully_deleted: "成功删除",
        nodes: "个节点",
        lock_failed: "锁定失败",
        locked_successfully: "锁定成功",
        unlock_failed: "解锁失败",
        unlock_successfully: "解锁成功",
        collection_success: "收藏成功",
        collection_failed: "收藏失败",
        unfavorite_successfully: "取消收藏成功",
        failed_to_unfavorite: "取消收藏失败",
        cancelling_collection: "正在取消收藏",
        cancelling_attention: "正在取消关注",
        etc: "等",
        files: "个文件",
        folders: "个文件夹",
        tags: "条标签",
        enter_name_for_zipfile: "请填写压缩文件的名称",
        select_path: "请选择路径",
        select_the_file_to_compressed: "请选择需要压缩的文件",
        compressed_successfully: "压缩成功",
        compression_failed: "压缩失败",
        enter_unzip_dir: "请填写解压到的文件目录",
        select_unzip_path: "请选择解压路径",
        unzip_dir_already_exists: "当前路径已存在,请更改解压文件夹名称",
        successfully_decompressed: "解压成功",
        unzip_failed: "解压失败",
        ask_edit_now: "文件已经创建完毕，是否立即进行编辑？",
        parent_path_does_not_exist: "上级路径不存在",
        enter_filename: "请填写文件名称",
        unsupported_file_type: "不支持的文件类型",
        name_already_exists: "名称已存在",
        name_already_exists_try: "已存在, 请换一个名字重试",
        switch_binding_state_tips: "切换绑定状态可能会导致上传组件绑定不上事件",
        ask_copy_to: "您确定需要将选择的节点复制到",
        ask_move_to: "您确定需要将选择的节点移动到",
        search_is_not_supported_in_this_mode: "不支持在该模式下检索",
        folder_created_successfully: "文件夹创建成功",
        renamed_successfully: "重命名成功",
        renamed_failed: "重命名失败",
        tagname_is_missing: "标签名称未填写",
        tags_deleted_successfully: "标签删除成功",
        filelevel_tips: "文件属于文件密级时某些操作会被禁止",
        inconsistent_pwds: "两次输入的密码不一致",
        enter_sms_verification_code: "请输入短信验证码",
        enter_old_pwd: "请输入旧密码",
        pwd_setting_successfully: "密码设置成功",
        pwd_setting_failed: "密码设置失败",
        avatar_updated_successfully: "头像更新成功",
        avatar_updated_failed: "头像更新失败",
        least_one_department: "用户至少属于一个部门",
        uname_cannot_be_empty: "用户名不可为空",
        modify_title_failed: "修改标题失败",
        modify_partuser_failed: "修改参与人失败",
        modify_closeday_failed: "修改截止日期失败",
        ask_delete_collaboration: "您确定删除该协作吗?",
        delete_cooperation_successfully: "删除协作成功",
        ask_delete_cooperation_space:
          "协作空间删除后文件将不可见,您确定需要删除吗?",
        enter_cooperation_space_name: "请输入协作空间名称",
        select_collaborator: "请选择参与协作的人员",
        select_cooperation_endtime: "请选择本次协作预计结束的时间.",
        folder_empty: "文件夹空空的.",
        upload_successfully: "上传成功",
        upload_failed: "上传失败",
        start_upload: "开始上传",
        cannot_previewed: "文件无法预览",
        uname_required: "用户名必填, 方便在编辑时识别您",
        sharelink_not_exist: "分享链接不存在或已被取消",
        sharelink_not_accessible: "分享链接不可访问",
        sms_sent_successfully: "短信发送成功,请注意查收",
        sms_sent_failed: "发送短信失败",
        enter_phone_number: "请输入手机号码",
        pwd_verification_failed: "密码验证失败",
        remove_share_successfully: "移除分享成功",
        remove_share_failed: "移除分享失败",
        only_select_single_sharelink_to_copy: "只能选择单个分享链接进行复制",
        link_and_pwd_join_clipboard: "链接及密码已放入粘贴板",
        link_join_clipboard: "链接已放入粘贴板",
        share_does_not_exist: "分享不存在",
        dirrange_not_selected: "文件夹范围未选择",
        diradmin_unfilled: "目录管理员未填写",
        licensablerange_unfilled: "可授权范围未选择",
        licensabletype_not_selected: "可授权类型未选择",
        deleting_ploy: "正在删除{0}条策略",
        deleting_task: "正在删除{0}条任务",
        deleting_tag: "正在删除{0}条标签",
        successfully_delete_nodes: "成功删除{0}个节点",
        diradmin_saved_successfully_but_auth_failed:
          "目录管理员保存成功,但授予该用户权限失败",
        file_does_not_exist: "文件不存在",
        select_user: "请选择用户",
        no_data_has_been_found: "没有查询到数据",
        no_pms_info_found: "没有查到权限信息",
        select_analysis_file: "请选择需要分析的文件",
        select_analysis_operationtype: "请选择需要分析的操作类型",
        select_statistical_dir_range: "请选择统计目录范围",
        select_statistical_user_range: "请选择统计用户范围",
        ask_restore_to: "您确定需要将选择的节点恢复到:",
        successful_migration: "迁移成功",
        data_loading_failed: "数据加载失败",
        tag_status_color_not_selected: "标签状态颜色未选择",
        prohibited_operation_type_not_selected: "禁止操作类型未选择",
        jumping_please_wait: "正在跳转, 请稍后",
        select_authorized_range: "请选择需要授权的用户范围",
        ask_unshare: "您确定需要取消该分享链接?",
        file_sent_successfully: "文件发送成功",
        link_generated_successfully: "链接生成成功",
        enter_access_pwd: "请输入访问密码",
        watermark_savepdftext_prompt: "导出PDF时水印文本长度不可大于100",
        watermark_previewtext_prompt: "预览文件时水印文本长度不可大于100",
        rootdir_reached: "已到达根目录",
        select_authorized_pms: "请选择需要授予的权限",
        select_pms_setupuser: "请选择权限设置人",
        select_pms_owner: "请选择权限所属人",
        no_pms: "权限受限",
        major_version_is_empty: "主版本为空",
        minor_version_is_empty: "次版本为空",
        get_version_number_failed: "版本号获取失败",
        edition_setting_failed: "版次设置失败",
        attr_rule_has_been_deleted: "该属性规则已被删除",
        removal_failed: "移除失败",
        removed_successfully: "移除成功",
        no_major_version_selected: "未选择主版本",
        no_minor_version_selected: "未选择次版本",
        please_fill_attr: "请填写属性",
        please_select_the_attr_to_be_added: "请选择需要添加的属性",
        confirm_jump_detial: "确认跳转到该文件的详情页面?",
        enter_version_desc: "请输入版本描述",
      },
      text: {
        file: "文件",
        dir: "目录",
        folder: "文件夹",
        current_position: "当前位置",
        path: "路径",
        tag: "标签",
        system: "系统",
        docspace: "文档区",
        tenantdoc: "公司文档",
        teamdoc: "团队文档",
        basicattr: "基本属性",
        fileversion: "版本记录",
        filelogs: "操作日志",
        filemeta: "业务表单",
        filelinkcharts: "相关文件",
        tenantdoccfg: "文件文件夹策略",
        pmsmanagement: "权限管理",
        diradmins: "目录管理员",
        dirrecycle: "回收站",
        dirlogs: "文件操作日志",
        tenantdoccfgs: "子文件夹策略列表",
        watermarkcfg: "水印策略",
        basicinfo: "基本信息",
        filename: "文件名称",
        dirname: "文件夹名称",
        currentversion: "当前版本",
        currentoperating: "文件操作",
        cuser: "创建者",
        fileposition: "文件位置",
        dirposition: "文件夹位置",
        dirpath: "文件夹路径",
        size: "大小",
        filesize: "文件大小",
        dirsize: "文件夹大小",
        ctime: "创建时间",
        vuser: "修改者",
        space: "所属空间",
        vtime: "修改时间",
        revisiontime: "修订时间",
        filepms: "文件权限",
        lock: "锁定",
        lockinfo: "锁定信息",
        filetag: "文件标签",
        filelevel: "文件密级",
        businessfeature: "业务特征",
        teaminfo: "团队信息",
        launcher: "发起人",
        partuser: "参与人",
        setupuser: "设置人",
        start_date: "起始日期",
        end_date: "结束时间",
        createtime: "发起时间",
        createday: "发起日期",
        closetime: "截止时间",
        closeday: "截止日期",
        smartsummary: "智能摘要",
        smarttags: "智能标签",
        same_content_file: "相同内容文件",
        askviewurl: "预览文件",
        askdownload: "下载文件",
        newfile: "上传文件",
        updatefile: "更新文件",
        delfile: "删除文件",
        deldir: "删除文件夹",
        mkdir: "创建文件夹",
        rendir: "重命名文件夹",
        renfile: "重命名文件",
        move: "移动文件",
        on: "于",
        diradmin: "目录管理员",
        pmslist: "权限列表",
        version: "版本",
        filemd5: "文件MD5",
        operator: "操作人",
        operationtype: "操作类型",
        operationparam: "操作参数",
        operationip: "操作IP",
        operationtime: "操作时间",
        dirrange: "目录范围",
        select_one_user: "选择一个用户",
        select_one_or_more_groups: "选择一个或多个组",
        select: "选择",
        issued_diradmin: "下发目录管理员",
        not_allowed: "不允许",
        allow: "允许",
        allow_size: "允许大小",
        actual_size: "实际大小",
        licensablerange: "可授权范围",
        licensabletype: "可授权类型",
        allow_to_issue: "允许下发",
        yes: "是",
        no: "否",
        settime: "设置时间",
        expiredate: "过期日期",
        showall: "全部显示",
        no_graphics_data: "暂无图形数据",
        change_batch: "点击换一批",
        currentdir: "当前文件夹",
        system_supports_watermark_type: "系统支持水印类型",
        insert_watermark_info_when_exporting: "导出PDF时自动插入水印信息",
        insert_user_info_when_exporting: "导出PDF时自动插入用户信息",
        watermark_on_exporting_enter: "导出PDF时启用自定义水印",
        insert_watermark_info_during_preview: "预览文件时自动插入水印信息",
        insert_user_info_during_preview: "预览文件时自动插入用户信息",
        space_quota_strategy: "空间限额策略",
        quota_global_placeholder: "单位为MB",
        quota_placeholder: "单位为MB, 为空表示不限制",
        upload_file_type_strategy: "上传文件类型策略",
        versionup: "版本更新策略",
        allow_upload_file_types: "允许上传文件类型",
        prohibited_uploading_file_types: "禁止上传文件类型",
        fillin_suffix_placeholder:
          "填写文件后缀名, 多个用英文逗号隔开. 如: ppt,pptx,pdf",
        rolling_major_version: "滚动主版本",
        rolling_minor_version: "滚动次版本",
        versionup_caption:
          "滚动主版本, 表示更新文件时会滚动主版本号; 滚动次版本, 表示更新文件时默认会滚动次版本号; 若上个版本为定稿版本, 则更新文件时会强制滚动主版本号.",
        authorized_user: "授权用户",
        specify_user_range: "指定用户范围",
        user_range: "用户范围",
        pmstypes: "权限类型",
        pms_policy: "权限策略",
        view: "查看",
        not: "无",
        deleting: "正在删除",
        item: "项",
        select_user_or_user_range: "选择用户或用户范围",
        starttime: "开始日期",
        endtime: "结束日期",
        name: "名称",
        selectdir: "选择文件夹",
        enable_minor_version: "启用次版本",
        enable: "启用",
        disable: "禁用",
        unlimited: "不限",
        allowed_types: "允许的类型",
        taboo_types: "禁止的类型",
        search_by_name: "按名称检索...",
        search_by_admin: "按管理员检索...",
        search_by_user: "按用户检索...",
        admin_can_perform_operations:
          "可执行文件夹策略、权限管理、回收站等目录管理操作",
        businessform_help1: "当前文件无业务表单数据且用户无添加业务表单权限",
        businessform_help2:
          "业务表单需在后台[业务中心]->[表单配置]中新建业务表单",
        locktime: "锁定时间",
        statistics_in_progress: "正在统计您选择的文档信息,请稍等...",
        calculating: "正在计算...",
        number_of_documents_for_this_task: "本次任务操作文档数量",
        task_is_being_executed_in_batch: "正在批量执行任务,请稍等...",
        the_doc_selected_s_being_copied: "正在复制您选择的文档,请稍等...",
        moving: "正在移动...",
        copying: "正在复制...",
        quantity_completed: "操作结束,已完成数量",
        failed_file: "失败文件",
        delete: "删除",
        personal_recycle_bin: "个人回收站",
        delete_time: "删除时间",
        target_path: "目标路径",
        zipfilename: "压缩文件名称",
        enter_compressed_filename: "请输入压缩后的文件名称",
        zip_tips: "云压缩支持1G大小且不超过500个文件数量",
        unzipfilename: "解压文件夹名称",
        enter_unzipped_filedir: "请输入解压后文件目录",
        unzip_tips: "在线解压支持不超过1G大小的文件",
        new: "新建",
        owned_dir: "所属目录",
        click_or_drag: "点击或拖拽",
        type: "类型",
        perform_update: "进行更新",
        file_search: "文件搜索",
        dir_search: "文件夹搜索",
        meta_search: "扩展属性搜索",
        name_filtering: "名称过滤",
        file_or_folder_name: "文件或文件夹名称",
        file_or_folder: "文件或文件夹",
        search_by_file_name: "按文件名称检索...",
        search_by_folder_name: "按文件夹名称检索...",
        first_level_file_filtering: "一级文件过滤...",
        new_folder: "新建文件夹",
        loading: "数据加载中....",
        no_data: "暂无数据",
        search_tags: "搜索标签",
        select_result: "选择结果",
        current_tags_group: "当前标签组",
        tags_group: "标签组",
        tagname: "标签名称",
        enter_tag_name: "请输入标签名称",
        currently_no_tags: "当前暂无标签",
        personal_center: "个人中心",
        personal_info: "个人资料",
        change_password: "修改密码",
        send_messagees: "发送短信",
        login_phonenumber: "登录手机号",
        security_verification_method: "安全验证方式",
        old_password: "旧密码",
        verification_code: "验证码",
        enter_the_old_pwd: "请输入旧密码",
        sms_code: "短信码",
        login_pwd: "登录密码",
        enter_the_pwd: "请输入密码",
        confirm_pwd: "确认密码",
        click_to_select_the_picture_to_update: "点击选择图片进行更新",
        login_account: "登录账号",
        actual_name: "姓名",
        enter_actual_name: "请输入用户真实姓名",
        email: "邮箱",
        enter_email: "请输入电子邮箱,可用于信息接收",
        phone_number: "手机号码",
        enter_phone_number: "请输入手机号码",
        office_phone: "办公电话",
        enter_office_phone: "请输入电话号码",
        department: "部门",
        role: "角色",
        user: "用户",
        job_number: "工号",
        position: "职位",
        remarks: "备注",
        cooperation_list: "协作列表",
        my_initiated: "我发起的",
        my_participated: "我参与的",
        collaboration_title: "协作标题",
        all_day: "全天",
        collaboration_desc: "协作空间描述",
        tips: "提示",
        collaboration_tips:
          "右侧为协作内容空间存放位置,您可以初始化一些文档或点击上传选择任意位置的文档.",
        uname: "用户名",
        enter_nickname_or_realname: "可以是昵称或真实姓名, 方便在编辑时识别您",
        action: "操作",
        this_share_requires_pwd_verification: "此分享需要使用密码进行验证",
        password: "密码",
        link_has_expired_contact_sender: "该链接已失效，请联系发送链接人",
        link_maybe_invalid: "链接可能失效",
        filename_sendnote_sendersearch: "文件名称、发送备注、发送人检索",
        sharer: "分享人",
        receiver: "接收人",
        locker: "锁定人",
        deleter: "删除人",
        share_pms: "分享权限",
        share_notes: "分享备注",
        share_time: "分享时间",
        expiration_time: "失效时间",
        permanent_validity: "永久有效",
        expires_after_7_days: "7天后失效",
        expires_after_30_days: "30天后失效",
        expired: "已失效",
        access_password: "访问密码",
        shared_file_with_you: "给您分享了文件",
        use_pwd_authentication: "使用密码验证",
        filename_sendnote_search: "文件名称、发送备注检索",
        pwd_filename_search: "访问密码、文件名称检索",
        sendnote: "发送备注",
        no_sharing: "没有任何分享",
        link: "链接",
        no_notes: "没有任何备注",
        attention_type: "关注类型",
        attention_time: "关注时间",
        after_uploading_the_file: "上传文件后",
        after_updating_the_file: "更新文件后",
        after_renaming_the_file: "重命名文件后",
        after_moving_the_file: "移动文件后",
        after_downloading_the_file: "下载文件后",
        after_deleting_the_file: "删除文件后",
        followers: "关注人",
        page_not_found: "您要的页面未找到",
        select_one_folder: "选择一个文件夹",
        max_space_limit: "空间最大限额",
        max_limit: "最大限额",
        unit_is_mb_no_limit_if_blank: "单位为MB,不填则不限制",
        file_types_stored: "存放的文件类型",
        allowed_file_types: "允许的文件类型",
        prohibited_file_types: "禁止的文件类型",
        operation_desc: "操作描述",
        file_creator: "文件创建者",
        pms_number: "权限条目数",
        statistics_view: "统计视图",
        daily_statistics: "按日统计",
        weekly_statistics: "按周统计",
        monthly_statistics: "按月统计",
        start_time_range: "起始时间范围",
        end_time_range: "结束时间范围",
        select_dir_to_export_filelist: "选择一个目录导出该目录下所有文件清单",
        file_only: "仅文件",
        folder_only: "仅文件夹",
        files_and_folders: "文件及文件夹",
        filelist_to_be_analysis: "待分析的文件列表...",
        earliest_operation_date: "最早操作日期",
        latest_operation_date: "最早操作日期",
        operations_total: "操作总数",
        external_link_creator: "文件外链创建者",
        operating_equipment: "操作设备",
        most_statistics_tips:
          "最多统计100个热门文件,热门文件统计方式按文件使用频次来计算.",
        author: "作者",
        uses_total: "使用总次数",
        related_pms_settings: "相关权限设置",
        file_pms_details: "文件权限明细",
        export_select_dir_pmslist_tips:
          "导出用户在选择文件夹的子文件夹上的权限设置清单, 导出字段包含(列): 关联用户, 权限路径, 权限类型, 权限策略, 权限范围, 设置人, 设置时间",
        export_select_all_dir_pmslist_tips:
          "导出用户在选择文件夹的所有子文件夹及文件上具有的权限信息, 导出字段包含(列): 文件|文件夹路径, 关联用户, 权限类型(计算结果), 权限来源路径",
        global_config: "全局配置",
        user_config: "用户配置",
        modify_user_space_quota: "修改用户空间限额",
        add_user_space_quota: "添加用户空间限额",
        file_type_distribution_by_size: "文件类型分布(按大小)",
        file_type_distribution_by_number: "文件类型分布(按个数)",
        personal_space_usage: "个人空间使用情况",
        used_size: "已使用大小",
        remaining_space: "剩余空间",
        docspace_size: "文档区大小(已使用占比)",
        dirrecycle_size: "回收站大小(已使用占比)",
        select_type_of_data_transfer: "请选择数据转移类型",
        transfer_dir_manager: "转移目录管理员",
        transfer_dir_manager_desc: "将离职用户的目录管理员权限转移到目标用户",
        copy_personal_doc: "复制个人文档",
        copy_personal_doc_desc: "将离职用户的个人文档复制到目标用户的个人文档",
        transfer_user_pms: "转移用户权限",
        transfer_user_pms_desc: "将离职用户的用户权限转移到目标用户",
        transfer_user_share: "转移分享记录",
        transfer_user_share_desc: "将分享的发起人转移到目标用户",
        transfer_team_launcher: "转移团队发起人",
        transfer_team_launcher_desc: "将团队文档的发起人转移到目标用户",
        task_name: "任务名称",
        auto_encryption: "自动定密",
        execution_scope: "执行范围",
        notice_object: "通知对象",
        task_conditions: "任务条件",
        content: "内容",
        md5: "MD5",
        multiple_val_are_separate_by_commas: "多个值用英文逗号隔开",
        sort: "排序",
        file_level_name: "文件密级名称",
        file_level_color: "文件密级颜色",
        prohibited_operation_type: "禁止操作类型",
        tag_group_admin: "标签组管理员",
        tag_group_admin_list: "标签组管理员列表",
        team_name: "团队名称",
        files_number: "文件个数",
        max_space_single_team: "单个团队空间最大限额",
        sys_recommendation: "系统推荐",
        recommend_recent_desc: "根据最近的操作给您的推荐",
        popular_company_doc: "热门公司文档",
        recommend_count_recent_desc: "根据公司文档被操作次数给您的推荐",
        my_collection: "我的收藏",
        collection_n: "共收藏文件:{0}个",
        no_favorite_files: "您还没有收藏文件",
        work_info: "工作信息",
        share_with_me: "分享给我",
        description: "描述",
        permission: "权限",
        share_date: "分享日期",
        teamwork_in_progress: "进行中的团队协作",
        etc_files: "等{0}个文件",
        no_upload_files: "暂无上传文件",
        recent_actions: "最近操作",
        create_the_file: "创建该文件",
        no_doc_summary_info: "暂无文件摘要信息",
        unknown_file_name: "未知文件名",
        day: "天",
        permanent: "永久",
        preview_and_ownload: "预览下载",
        preview_only: "仅预览",
        send_to_colleague: "发送给同事",
        external_link: "外部链接",
        save_to: "转存",
        pwd_access: "密码访问",
        anonymous_access: "匿名访问",
        send_to_number: "共发送给{0}人",
        corporate_doc_growth_trends: "公司文档增长趋势",
        uploaded_file_number: "上传文件数量",
        pms_location: "权限位置",
        all_pms: "全部权限",
        only_name_visible: "仅名称可见",
        hide_it: "对其隐藏",
        collaboration_schedule: "协作日程",
        finished: "已完结",
        processing: "进行中",
        scan_with_phone: "使用手机扫一扫(点击下载二维码)",
        shareedit: "共享编辑",
        access: "访问",
        access_ip: "访问IP",
        access_device: "访问设备",
        access_homepage: "访问首页",
        does_not_exist: "不存在",
        no_recipient_selected_yet: "您还没有选择接收人",
        file_link: "文件链接",
        expire_after_days: "天后失效",
        choose_custom_period: "选择自定义期限",
        custom_period: "自定义期限",
        sharing_period: "分享期限",
        preview: "预览",
        download: "下载",
        modify_setting: "修改设置",
        sharing_setting: "分享设置",
        share_user: "分享用户",
        share_content: "分享内容",
        say_something: "说点什么吧",
        copy_link_and_pwd: "复制链接及密码",
        create_new_link: "创建新链接",
        address: "访问地址",
        max_number_visits: "最大访问次数",
        blank_means_unlimited: "不填表示无限制,如需要限制请输入次数(整数值)",
        with_pwd: "有密码",
        no_pwd: "无密码",
        blank_unlimited: "不填表示无期限",
        never_expire: "永不过期",
        setpms_expire_tips: "设置过期时间后,到期后权限将自动删除！",
        extended_attr: "扩展属性",
        team_space_size: "团队空间大小",
        status: "状态",
        set_edition: "设置版次",
        current_edition: "当前版次",
        required_attr_tips: "含有必填属性未填写,请点击设置属性继续操作",
        inherit_superior_pms: "继承上级权限",
        list_superior_pms: "列出上级权限",
        effective: "生效",
        invalid: "未生效",
        reset_attr: "重置属性",
        select_attr: "选择属性",
        attr_name: "属性名称",
        attr_value: "属性值",
        edit_edition: "编辑版次",
        version_number: "版本号",
        parent_directory: "上级目录",
        attr: "属性",
        userpms_help_desc: "被授予的用户范围将在共享给我的文件空间可见",
        no_extended_attr: "无扩展属性",
        related: "关联",
        current: "当前",
        reverse_related: "反向关联",
        file_related: "文件关联",
        version_desc: "版本描述",
        attention_help:
          "文件夹添加相应类型的关注后,文件夹内所有文件变更后将会发送系统消息通知您.",
        inheritance_pms: "继承权限",
        local_pms: "本地权限",
        pms_source: "权限来源",
        input_watermark: "输入水印信息",
        watermark_txt: "水印文本",
        showuser: "显示操作人",
        showdate: "显示时间",
      },
      pms: {
        visabled: "可见名称",
        preview: "预览文件",
        print: "打印文件",
        transpdf: "导出PDF",
        share: "分享文件",
        dwonload: "下载文件",
        newfile: "新建文件",
        newdir: "新建文件夹",
        modify: "修改文件",
        rename: "重命名",
        delete: "删除文件",
        deletedir: "删除文件夹",
        setmeta: "设置属性",
        visabledhistory: "历史版本可见",
        rollbackversion: "版本回滚",
        deleteversion: "版本删除",
        recycled: "回收站管理",
        viewlog: "日志查询",
        settag: "文件定密",
        finallversion: "定稿版本", //已移除
      },
    },
    im: {
      text: {
        sendCloudFile: "发送云端文件",
        sendLocalFile: "发送本地附件",
        quit_group: "您确定要退出该群吗？",
        del_group: "您确定要解散该群吗？",
        enter_groupName: "请输入群名称",
        groupName: "群名称",
        imwellcome:
          "您可以在此发起用户聊天频道、群组聊天频道及您固定的所在部门频道",
        searchcontacts: "搜索联系人",
        group: "群组",
        news: "消息",
        startchat: "发起聊天",
        chatchannel: "聊天频道",
        organization: "组织架构",
        groupdetails: "群详情",
        create: "创建",
        groupmembers: "群成员",
        // 以下来自 中华哥 XX
        disband_group_chat: "解散群聊",
        leave_group_chat: "退出群聊",
        department_members: "部门成员",
        member_removed_successfully: "成员移除成功",
        compression_failed: "压缩失败",
        folder_not_support_preview: "文件夹不支持预览",
        chat_record: "聊天记录",
        collect: "收藏",
        forward: "转发",
        withdraw: "撤回",
        edit_group_name: "修改群组名称",
        chat_file: "聊天文件",
        chat_images: "聊天图片",
        add_members: "添加成员",
        member_information: "成员信息",
        send_cloud_documents: "发送云文档",
        send_pictures: "发送图片",
        send_local_attachments: "发送本地附件",
        you_withdrew_message: "您撤回了一条消息",
        withdrew_message: "撤回了一条消息",
        forwarded_successfully: "转发成功",
        forward_failed: "转发失败",
        collection_success: "收藏成功",
        collection_failed: "收藏失败",
        withdrawal_failed: "撤回失败",
        message_failed_send: "消息发送失败",
        application_news: "应用消息",
        attachment_may_no_exist: "附件可能已不存在",
        search_users: "搜索用户",
        rollingload: "滚动加载",
        groupSettings: "聊天设置",
      },
    },
    platform:{
      newflow:'发起流程',
      workflow:'工作流程',
      launchAndUnfinished:'发起在审',
      attendedAndUnfinished:'参与在审',
      attendedAndEnded:'参与完结',
      myTodo:'我的待办',
      launchByMe:'发起完结',
    },
    doc:{
      enterName:'请输入名称',
      confirmDel:'您确定要删除？',
      enterFolderName:'请输入文件夹名称',
      enter:'请输入',
      name:'名称',
      selected:'已选中',
      item:'个文件'
    }
  };
});
